import ContentBody from 'components/content-body/content-body';
import ContentContainer from 'components/content-container/content-container';
import ContentHeaderTitle from 'components/content-header-title/content-header-title';
import ContentHeader from 'components/content-header/content-header';
import Content from 'components/content/content';
import React, { FunctionComponent } from 'react';
import { Card } from 'semantic-ui-react';
import { BackupCard } from './backup-card/backup-card';
import { ExportGuideCard } from './export-guide-card/export-guide-card';
import { ExportSepaCard } from './export-sepa-card/export-sepa-card';
import { ImportZohoSubscriptionsCard } from './import-zoho-subscriptions-card/import-zoho-subscriptions-card';
import { InvoicesAnomalyDetectorCard } from './invoice-anomaly-detector-card.tsx/invoices-anomaly-detector-card';
import { ProInterventionUpdateCard } from './pro-intervention-update-card/pro-intervention-update-card';
import { RefreshMaterializedViewsCard } from './refresh-materialized-views-card/refresh-materialized-views-card';
import { SearchEngineUpdateCard } from './search-engine-update-card/search-engine-update-card';
import { SyncSpatialReviewsCard } from './sync-spatial-reviews-card/sync-spatial-reviews-card';
import { ToastsPreviewCard } from './toasts-preview-card/toasts-preview-card';

const ToolsPage: FunctionComponent = () => (
  <Content>
    <ContentHeader>
      <ContentHeaderTitle>Outils</ContentHeaderTitle>
    </ContentHeader>
    <ContentBody>
      <ContentContainer>
        <Card.Group>
          <BackupCard />
          <RefreshMaterializedViewsCard />
          <InvoicesAnomalyDetectorCard />
          <ExportGuideCard />
          <ExportSepaCard />
          <SearchEngineUpdateCard />
          <ProInterventionUpdateCard />
          <SyncSpatialReviewsCard />
          <ImportZohoSubscriptionsCard />
          <ToastsPreviewCard />
        </Card.Group>
      </ContentContainer>
    </ContentBody>
  </Content>
);

export default ToolsPage;
